<template>
    <main class="resource flex" v-if="resource" :class="{'body': !isAllowedPrint}">
        <div class="sidebar">
            <!-- Commenting this button out for Empowering Writers -->
            <router-link class="back flex flex-align" :to="{name: 'product.units.unit'}" v-if="publisher.id !== 2500192111">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z"/>
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <line x1="5" y1="12" x2="11" y2="18" />
                    <line x1="5" y1="12" x2="11" y2="6" />
                </svg>
                Back to Unit
            </router-link>
            <nav>
                <!-- TODO Resource attachments in this sidebar -->
                <!-- <div class="snapshot" v-for="snapshot of snapshots" :key="snapshot.id">
                    <h3>{{snapshot.title}}</h3>
                    <div class="unit flex" v-for="unit of snapshot.units" :key="unit.id">
                        <router-link :to="{name: 'product.units.unit', params: {unit: unit.id}}" class="unit-title block">{{unit.title}}</router-link>
                    </div>
                </div> -->
            </nav>
        </div>
        <div class="layout ff">
            <div class="resource-header">
                <div class="flex flex-align">
                    <!-- <input type="text" class="search medium" placeholder="Search Document" /> -->
                    <a @click="assign" target="_blank" class="button external flex flex-align">
                        Assign to Students
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-external-link" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z"/>
                            <path d="M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5" />
                            <line x1="10" y1="14" x2="20" y2="4" />
                            <polyline points="15 4 20 4 20 9" />
                        </svg>
                    </a>
                    <a :href="resource.metadata.url" target="_blank" class="button grey download flex flex-align" v-if="resource.data.downloadable">
                        Download
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-cloud-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z"/>
                            <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4" />
                            <line x1="12" y1="13" x2="12" y2="22" />
                            <polyline points="9 19 12 22 15 19" />
                        </svg>
                    </a>
                </div>
                <h1>{{resource.title}}</h1>
                <h2 v-if="resource.metadata.description">{{resource.metadata.description}}</h2>
            </div>
            <template v-if="resource">
                <component :is="type" :key="resource.id" :id="resource.id" :configuration="resource" />
            </template>
        </div>
    </main>
</template>

<script>
    import Assign from '@/components/modals/Assign.vue';

    const types = {
        lessonPlan: 'page',
        assignment: 'page',
        attachment: {
            video: 'media',
            image: 'media'
        },
        embed: 'media'
    };

    export default {
        name: 'Resource',
        data(){
            return {
                loading: false,
                resource: null
            };
        },
        methods: {
            change(){
                this.$modal.show(Chapters, {}, {width: 800, height: 600, classes: 'modal'});
            },
            assign(){
                this.$modal.show(Assign, {resource: this.resource}, {width: 700, height: 'auto', classes: 'modal'});
            }
        },
        computed: {
            publisher(){
                return this.$store.getters.publisher;
            },
            isAllowedPrint() {
                const allowPrinting = localStorage.getItem('allow_package_printing') ? true : null;
                return (allowPrinting !== null) ? true : false;
            },
            product(){
                return this.$store.getters.product;
            },
            chapter(){
                return this.$store.getters.chapter;
            },
            user(){
                return this.$store.state.user;
            },
            active(){
                return this.$route.params.resource;
            },
            type(){
                if(types.hasOwnProperty(this.resource.type)){
                    const type = types[this.resource.type];

                    if(typeof type === 'object'){
                        return type.hasOwnProperty(this.resource.contentType) ? type[this.resource.contentType] : this.resource.contentType;
                    }

                    return types[this.resource.type];
                }

                return this.resource.type;
            }
        },
        created(){

        },
        watch: {
            active: {
                immediate: true,
                handler(){
                    this.$http.get(`/contents/${this.active}`, {
                        params: {
                            'include-deep': true
                        }
                    })
                    .then(response => {
                        this.resource = response.$data;
                        this.$store.dispatch('sessions/createSession', this.resource.id);
                    })
                    .catch(error => {
                        console.error('Error loading resource:', error);
                        this.$toasted.error('There was an error loading this resource. Please check the console for details.');
                    });
                }
            }
        },
        beforeDestroy() {
            this.$store.dispatch('sessions/stopSessionExtension');
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .resource
    {
        width: 100vw;
        min-height: 100vh;
        align-items: stretch;
    }

    .back
    {
        font-size: 16px;
        font-weight: 500;
        padding-left: 50px;
        color: @base;
        height: 40px;
        padding: 10px 0;

        .icon
        {
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-right: 10px;
        }
    }

    .sidebar
    {
        padding: 40px 50px;
        flex: 0.3;
        background: @f8;
    }

    .layout
    {
        padding: 50px 100px;
    }

    .resource-header
    {
        max-width: 800px;
        padding-bottom: 50px;
        border-bottom: 1px solid @e4;

        h1
        {
            margin-top: 30px;
        }

        h2
        {
            color: @grey;
            font-weight: 400;
            font-size: 18px;
            margin-top: 30px;
        }

        .button
        {
            margin-right: 20px;
            padding-right: 12px;

            .icon
            {
                width: 19px;
                margin-left: 10px;
            }

            &.download
            {
                .icon
                {
                    margin-bottom: 2px;
                }
            }
        }
    }
    @media print {
    .body * {
        visibility: hidden;
    }

    .body:after {
        content: "Printing is disabled.";
        visibility: visible;
        display: block;
        text-align: center;
        font-size: 20px;
        margin-top: 50vh;
        transform: translateY(-50%);
    }
    .layout {
        padding: 0 !important;
    }
    .sidebar {
        display: none !important;
    }

    .pdf {
        width: 100% !important;
    }
    .page {
        width: 100% !important;
         box-shadow:none !important;
    }
    .resource-header {
        display: none !important;
    }

}
</style>